import { nextTick } from 'vue';
import { useCommonData } from '@/hooks';
import * as QRCode from 'easyqrcodejs';

export const useSurfModuleQrcode = () => {
	const { getColumnData, generateMobileModuleUrl } = useCommonData();

	const queryModuleQrcode = (container, moduleId, fallbackUrl) => {
		if (!container || !moduleId) return;

		const { logo } = getColumnData.value;
		const qrcodeURL = generateMobileModuleUrl(moduleId);

		const width = 256;
		const height = 256;
		const config = {
			colorDark: '#333', //二维码颜色
			colorLight: '#fff', //二维码背景色
			correctLevel: QRCode.CorrectLevel.M, //容错率，L/M/H
			logo: logo,
			crossOrigin: 'anonymous',
			quietZone: 0,
			width,
			height,
			logoWidth: width / 5,
			logoHeight: height / 5
		};

		nextTick(() => {
			new QRCode(container, {
				...config,
				text: qrcodeURL,
				onRenderingEnd: (options, dataURL) => {
					fallbackUrl?.(dataURL);
				}
			});
		});
	};

	const openModuleLink = (moduleId) => {
		const url = generateMobileModuleUrl(moduleId);
		if (url) {
			window.open(url, '_blank');
		}
	};

	return {
		queryModuleQrcode,
		openModuleLink
	};
};
